import { isLength } from 'validator';
import Attach from '@tools/attach';
import { replaceElement } from '@tools/dom';
import TwigFormValidator from '@tools/twig-form/validator';

/**
 * User profile edit password component
 */
export default function () {
  function processForm() {
    const validator = new TwigFormValidator({
      formSelector: '#form-user-edit-password',
      rules: {
        'change_password_form[current_password]': [ 'required', (value) => isLength(value, { min: 6 }) ],
        'change_password_form[plainPassword][first]': [ 'required', (value) => isLength(value, { min: 6 }) ],
        'change_password_form[plainPassword][second]': [ 'required', (value) => value === document.getElementById('change_password_form_plainPassword_first').value ],
      },
      messages: {
        'change_password_form[current_password]': [ 'required', 'passwordTooShort' ],
        'change_password_form[plainPassword][first]': [ 'required', 'passwordTooShort' ],
        'change_password_form[plainPassword][second]': [ 'required', 'passwordNotTheSame' ],
      },
      onSuccess: (event) => {
        Attach.asyncSubmit(event).then((result) => {
          if (result.data.reload) {
            window.location.reload();
          } else {
            replaceElement('#user-profile-change-password-block .container', result.data, '.container');
            processForm();
          }
        });
      },
    });
    validator.init();
  }

  if (document.getElementById('user-profile-change-password-block')) {
    processForm();
  }
}
